// extracted by css-extract-rspack-plugin
export default {"TaskListMenuTriggerButton":"TaskListMenu-module__TaskListMenuTriggerButton__zzTV4"};